module.exports = __webpack_public_path__ + "static/media/5. Domino azul, Óleo y resina sobre lámina acrílico, 100x 66 x 4 cm, 2020 copy.ce502d99.png";